import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { catchError, from, mergeMap, Observable, throwError } from 'rxjs';
import { AuthorizationService } from '../../shared/services/authorization.service';
import config from '../../../assets/config.json';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { EmulationService } from '../../shared/services/emulation.service';
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private MFALoginKeyName = config.MFALoginKeyName;
  constructor(
    private _auth: AuthorizationService,
    private _router: Router,
    private _emulationService: EmulationService,
  ) {}

  private isAuthenticated(): Observable<boolean> {
    return from(this._auth.isAuthenticated());
  }

  private getAccessToken(): Observable<string> {
    return from(this._auth.getAccessToken());
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const keyConfig = { ...config };
    return this.isAuthenticated().pipe(
      mergeMap((isAuthenticated) => {
        if (!isAuthenticated) {
          return next.handle(request);
        }
        return this.getAccessToken().pipe(
          mergeMap((accessToken) => {
            let req;
            if (request.headers.get('app-source')) {
              req = request.clone({
                setHeaders: {
                  Authorization: `Bearer ${accessToken}`,
                },
              });
            } else {
              req = request.clone({
                setHeaders: {
                  Authorization: `Bearer ${accessToken}`,
                  'Ocp-Apim-Subscription-Key': keyConfig.Ocp_Apim_Subscription_Key,
                },
              });
            }
            return next.handle(req).pipe(
              catchError((error) => {
                if (
                  error instanceof HttpErrorResponse &&
                  error.url?.startsWith(environment.apiHost) &&
                  !error.url?.includes('GetHeader') &&
                  !error.url?.includes('MFA/VerifyMfa')
                ) {
                  switch (error.status) {
                    case 500: // Internal Server Error
                      this._router.navigate(['/server-error']);
                      break;
                    case 401: // Unauthenticated error
                      this._emulationService.stopEmulation(); // Stop emulation if any
                      document.cookie = `${this.MFALoginKeyName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; Secure;`; // Remove MFA verification cookie
                      this._auth.startAuthentication(); // Start authentication process
                      break;
                    default:
                      break;
                  }
                }
                return throwError(() => error);
              }),
            );
          }),
        );
      }),
    );
  }
}
